import axios from 'axios';

export default class PatientService {
    invitePatient(patientId) {
        return axios.post(`/v2/mobile-app/${patientId}/invite`);
    }
}
